// DeleteConfirmationDialog.jsx - Delete Confirmation Dialog

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import * as actions from '../redux.actions';
import * as selectors from '../redux.selectors';

const DeleteConfirmationDialog = () => {
    const dispatch = useDispatch();
    const open = useSelector(selectors.selectDeleteDialogOpen);
    const userKpiToDelete = useSelector(selectors.selectUserKpiToDelete);

    const handleClose = () => {
        dispatch(actions.closeDeleteDialog());
    };

    const handleConfirm = () => {
        if (userKpiToDelete) {
            dispatch(actions.deleteUserKpiRequest(userKpiToDelete.id));
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningAmberIcon color="warning" />
                    Confirm Delete
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    Are you sure you want to delete this User KPI assignment?
                </Typography>
                {userKpiToDelete && (
                    <Box sx={{ mt: 2, p: 2, backgroundColor: (theme) => alpha(theme.palette.divider, 0.06), borderRadius: 1 }}>
                        <Typography variant="body2">
                            <strong>User:</strong> {userKpiToDelete.userName || userKpiToDelete.userId}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Period:</strong> {userKpiToDelete.periodName || '-'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Goals:</strong> {userKpiToDelete.goalsCount || 0}
                        </Typography>
                    </Box>
                )}
                <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                    This action cannot be undone. All associated goals and scores will be permanently deleted.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose} variant="outlined">
                    Cancel
                </Button>
                <Button onClick={handleConfirm} variant="contained" color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
